import { render } from "./AlertNew.vue?vue&type=template&id=282c8ca4&scoped=true"
import script from "./AlertNew.vue?vue&type=script&lang=js"
export * from "./AlertNew.vue?vue&type=script&lang=js"

import "./AlertNew.vue?vue&type=style&index=0&id=282c8ca4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282c8ca4"]])

export default __exports__